import { removeArrayElement } from "../../../utils/general";
import { ADD_EXPENSE, DELETE_EXPENSE, FETCH_EXPENSES, LOG_OUT_USER } from "../../actions/actionTypes";

const fetchExpensesReducer = (expenses, payload) => {

    let newExpenses = payload.appendData ? [ ...expenses ] : []
    for(let expense of payload.expenses){
        newExpenses.push(expense.expenseId);
    }
    let uniqueIds = [...new Set(newExpenses)];
    return uniqueIds;
}

const addExpenseReducer = (expenses, payload) => {
    let newExpenses = [ ...expenses ];
    newExpenses.unshift(payload.expense.expenseId)

    return newExpenses;
}

const deleteExpenseReducer = (expenses, payload) => {
    let newExpenses = [ ...expenses ];
    let remainingExpenses = removeArrayElement(newExpenses, payload.expenseId)
    
    return remainingExpenses;
}

const expensesOrderReducer = (state=[], action) => {
    let expenses = state;
    if (action && action.payload && !action.payload.errors){
        switch(action.type){
            case FETCH_EXPENSES:
                return fetchExpensesReducer(expenses, action.payload);
            case ADD_EXPENSE:
                return addExpenseReducer(expenses, action.payload);
            case DELETE_EXPENSE:
                return deleteExpenseReducer(expenses, action.payload);
            case LOG_OUT_USER:
                return [];
            default:
                return expenses;
        }
    }
    return expenses;
}

export default expensesOrderReducer;